import axios from 'axios';

import { API } from '@/config/constants';


export const getUsers = async (params, config) => {
  const response = await axios.get(`${API}/users`, config ? { ...config, ...(params ? { params } : {}) } : params ? { params } : undefined);
  return response.data;
};

export const getDesktopUserDirectory = async (config, backendUrl) => {
  const response = await axios.get(`${backendUrl ? `${backendUrl}/api` : API}/users/desktop-directory`, ...config ? [config] : []);
  return response.data;
};

export const createUser = async (data, config) => {
  const response = await axios.post(`${API}/users`, data, ...(config ? [config] : []));
  return response.data;
};

export const updateUser = async (userId, data, config) => {
  const response = await axios.put(`${API}/users/${userId}`, data, ...(config ? [config] : []));
  return response.data;
};

export const disableUser = async (userId, config) => {
  const response = await axios.delete(`${API}/users/${userId}`, ...(config ? [config] : []));
  return response.data;
};

export const reactivateUser = async (userId, password, config) => {
  const response = await axios.post(`${API}/users/${userId}/reactivate`, { password }, ...(config ? [config] : []));
  return response.data;
};

export const resetUserPassword = async (userId, password, config) => (
  updateUser(userId, { password }, config)
);
